export type LocationBadge = { label: string; color: string; borderColor: string; bgColor: string };

type BadgeInput = { source: 'vehicle'; cardType: 'delivery' | 'loading' } | { source: 'unassigned' };

/**
 * 詳細パネルの表題に付ける地点種別バッジ。
 * サンプル (route-planner: components/dispatch/DispatchDetailPanel.tsx:355-362, 413-419) と同じ
 * 「降地=青 / 積地=橙 / 未割当=赤」。色は 3 種を見分けるためのもので、共有しない。
 *
 * Why not 呼び出し側で alpha を足す: 未割当の色は hsl(var(--destructive)) で、
 * 末尾の ')' を置換すると var() の閉じ括弧を壊す。薄色はここで組み立てる。
 */
export function resolveLocationBadge(input: BadgeInput | null | undefined): LocationBadge | null {
  if (!input) return null;
  if (input.source === 'unassigned') {
    return {
      label: '未割当',
      color: 'hsl(var(--destructive))',
      borderColor: 'hsl(var(--destructive) / 0.35)',
      bgColor: 'hsl(var(--destructive) / 0.1)',
    };
  }
  return input.cardType === 'delivery'
    ? {
      label: '降地',
      color: 'hsl(210 80% 50%)',
      borderColor: 'hsl(210 80% 50% / 0.35)',
      bgColor: 'hsl(210 80% 50% / 0.14)',
    }
    : {
      label: '積地',
      color: 'hsl(30 90% 45%)',
      borderColor: 'hsl(30 90% 45% / 0.35)',
      bgColor: 'hsl(30 90% 45% / 0.14)',
    };
}
